import React, { useEffect, useRef, useState } from 'react'
import { Badge, Button, Card, Col, Container, Dropdown, Form, Modal, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { getSchoolBySelection } from '../../actions/schoolsActions'
import { getSelection } from '../../actions/selectionsActions'
import { addChoose, dimissCandidate, getChoosesBySelection, getInterviewsCalendarBySchool, scheduleInterview, viewVideo, removeChoose, sendOfferLetter, addIncorporationDate, getChoose, addInterviewNote, editInterviewNote, deleteInterviewNote, deleteMultipleInterviewNotes } from '../../actions/choosesActions'
import Swal from 'sweetalert2'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction"
import '@fullcalendar/bootstrap5/main.css'
import '@fullcalendar/daygrid/main.css'
import esLocale from '@fullcalendar/core/locales/es'
import { getCourseSubjects, getLevels } from '../../actions/miscellaneousActions'
import CandidateProfile from '../admin/CandidateProfile'
import { editMultiSchoolStock, editStock, getReducedStocksBySchool } from '../../actions/stocksActions'
import { PDFViewer } from '@react-pdf/renderer'
import OfferLetter from '../../components/pdfs/OfferLetter'
import { reportCandidate } from '../../actions/candidatesActions'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import { getSchoolStaffsBySchool } from '../../actions/schoolStaffActions'
import InterviewSection from '../../components/jitsi/InterviewSection'
import CreatableSelect from 'react-select/creatable';
import { getLabelsBySelection, registerLabels } from '../../actions/labelsActions'

export default function CandidateData() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const params = useParams()
    const dispatch = useDispatch()
    const calendar = useRef(null)

    const {school, schooluser} = useSelector(state=>state.schools)
    const {selection} = useSelector(state=>state.selections)
    const {chooses, result, loading, schedule, choose, noteLoading} = useSelector(state => state.chooses)
    const {levels, subjects} = useSelector(state => state.miscellaneous)
    const {result: stocksResult, stocks} = useSelector(state => state.stocks)
    const {schoolStaffs} = useSelector(state=>state.schoolStaffs)
    const {labels, result: labelsResult, loading: labelsLoading} = useSelector(state=>state.labels)

    const [selectedCandidate, setSelectedCandidate] = useState(null)
    const [dimissReason, setDimissReason] = useState(null)
    const [dimissReasonDescription, setDimissReasonDescription] = useState(null)
    const [selectedVideo, setSelectedVideo] = useState(null)
    const [selectedInterviewDate, setSelectedInterviewDate] = useState(null)
    const [selectedInterviewTime, setSelectedInterviewTime] = useState(null)
    const [interviewDates, setInterviewDates] = useState([])
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [selectedCandidateProfile, setSelectedCandidateProfile] = useState(null)

    const [offerLetterData, setOfferLetterData] = useState({
        sexualCrimeCertification: true,
        step: 1
    })

    const [incorporationDate, setIncorporationDate] = useState(null)
    const [incorporationHour, setIncorporationHour] = useState(null)

    const [multiSchoolStockForm, setMultiSchoolStockForm] = useState(null)

    const [showReportModal, setShowReportModal] = useState(false)
    const [candidateReport, setCandidateReport] = useState(null)
    const [additionalComments, setAdditionalComments] = useState('')
    const [selectedOptions, setSelectedOptions] = useState([]);

    const [step, setStep] = useState(1)
    const [maxStep, setMaxStep] = useState(1)

    const [noteForm, setNoteForm] = useState(null)
    const [selectedNotes, setSelectedNotes] = useState([])

    const [isMeetingVisible, setIsMeetingVisible] = useState(false); // Controla si la reunión de Jitsi se muestra

    const [labelInput, setLabelInput] = useState('')
    const [labelsValue, setLabelsValue] = useState([])

    const onModalClose = () => {
        setSelectedCandidate(null)
        setDimissReason(null)
        setDimissReasonDescription(null)
    }

    const handleDimissSubmit = () => {
        if (selectedCandidate && dimissReason) {
            dispatch(dimissCandidate(selectedCandidate._id, dimissReason, dimissReasonDescription || t("selection.dimiss." + dimissReason + "Description", {name: `${selectedCandidate?.candidate?.firstname} ${selectedCandidate?.candidate?.lastname}`})))
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: t('selection.dimiss.formError')
            });
        }
    }

    const handleVideoClick = (choose) => {
        if (choose.videoPresentation) {
            setSelectedVideo(choose)
            dispatch(viewVideo(choose._id))
        }
    }

    const handleInterviewDateClick = (arg) => {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const clickedDate = new Date(arg.date)
        clickedDate.setHours(0, 0, 0, 0)
    
        if (interviewDates?.length < 3 && clickedDate >= today) {
            setSelectedInterviewDate(arg);
        }
    }

    const closeInterviewDate = () => {
        setSelectedInterviewTime(null)
        setSelectedInterviewDate(null)
    }

    const saveInterviewDate = () => {
        if (selectedInterviewTime) {
            setInterviewDates([
                ...interviewDates,
                {
                    date: selectedInterviewDate.date,
                    hour: selectedInterviewTime
                }
            ])
            closeInterviewDate()
        }
    }

    const handleEventClick = (e) => {
        if (e.event._def?.extendedProps?.type === "choose") {
            Swal.fire({
                icon: 'question',
                showCancelButton: true,
                showConfirmButton: true,
                text: t('selection.deleteInterviewDayQuestion'),
                cancelButtonText: t('global.cancel'),
                confirmButtonText: t('global.yes')
            }).then(result => {
                if (result.isConfirmed) {
                    setInterviewDates(interviewDates.filter((value, index) => index !== e.event._def.extendedProps.index))
                }
            })
        } else {
            setSelectedEvent(e.event._def?.extendedProps)
        }
    }

    const handleInterviewSave = () => {
        if (interviewDates.length === 3) {
            let index = -1
            if (selection?.videoPresentation && Number(selection?.interviews?.length || 0) + 2 > step) {
                index = step - 2
            } else if (!selection?.videoPresentation && Number(selection?.interviews?.length || 0) + 1 > step) {
                index = step - 1
            }
            dispatch(scheduleInterview(choose._id, index, interviewDates))
        }else{
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('selection.enoughDates')
            });
        }
    }

    const capitalizeFirstCharacter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        } else {
            return ''
        }
    }

    const handleEditStock = (candidate, movement) => {
        if (client?.rol === "MultiSchool") {
            let typeMovement = ''
            let typeStock = ''

            if(movement === 'addFavourite'){
                typeMovement = 'add'
                typeStock = 'favourite'
            }else if(movement === 'removeFavourite'){
                typeMovement = 'remove'
                typeStock = 'favourite'
            }else if(movement === 'addBlocked'){
                typeMovement = 'add'
                typeStock = 'blocked'
            }
            setMultiSchoolStockForm({
                movement: typeMovement,
                typeStock: typeStock,
                scope: 'all',
                candidate: candidate._id,
            })
        } else {
            let typeMovement = ''
            let typeStock = ''
            let swalText = ''
    
            if(movement === 'addFavourite'){
                typeMovement = 'add'
                typeStock = 'favourite'
                swalText = t('database.addFavouriteCandidateQuestion')
            }else if(movement === 'removeFavourite'){
                typeMovement = 'remove'
                typeStock = 'favourite'
                swalText = t('database.removeFavouriteCandidateQuestion')
            }else if(movement === 'addBlocked'){
                typeMovement = 'add'
                typeStock = 'blocked'
                swalText = t('database.addBlockCandidateQuestion')
            }
    
            Swal.fire({
                showConfirmButton: true,
                showDenyButton: true,
                confirmButtonText: t('global.confirm'),
                denyButtonText: t('global.cancel'),
                icon: 'question',
                text: t(swalText, {name: `${candidate.firstname} ${candidate.lastname}`})
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(editStock(school?._id, candidate._id, typeStock, typeMovement))
                }
            })
        }
    }

    const addCandidate = (choose) => {
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.confirm'),
            denyButtonText: t('global.cancel'),
            icon: 'question',
            text: t('selection.addCandidateQuestion', {name: `${choose.candidate.firstname} ${choose.candidate.lastname}`})
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeChoose(choose._id, false))
                dispatch(addChoose(params.id, choose.candidate._id, 'candidate'))
            }
        })
    }

    const handleSendOfferLetter = () => {
        dispatch(sendOfferLetter(choose._id, offerLetterData))
    }

    const handleCloseStockModal = () => {
        setMultiSchoolStockForm(null)
    }

    const handleSetIncorporationDate = () => {
        dispatch(addIncorporationDate(choose._id, incorporationDate, incorporationHour))
    }

    const handleOfferLetterSwitchChange = ({target}) => {
        setOfferLetterData({...offerLetterData, [target.name]: target.checked})
    }

    const handleOfferLetterChange = ({target}) => {
        setOfferLetterData({...offerLetterData, [target.name]: target.value})
    }

    const handleStockSubmit = (e) => {
        e.preventDefault()
        const formStateCopy = {...multiSchoolStockForm, multiSchool: client?.id}

        if (formStateCopy.scope === "current") {
            formStateCopy.school = school?._id
        }

        dispatch(editMultiSchoolStock(formStateCopy))
    }

    const handleReportModalClose = () => setShowReportModal(false)

    const handleReportModalShow = (toReport) => {
        setShowReportModal(true);
        setCandidateReport(toReport);
    }

    const handleReportSubmit = async () => {
        dispatch(reportCandidate(candidateReport, {school: client?.id, additionalComments, selectedOptions}))
    }

    const handleCheckChange = (event, option) => {
        setSelectedOptions((prevSelected) => {
            if (event.target.checked) {
                return [...prevSelected, option]
            } else {
                return prevSelected.filter((item) => item !== option)
            }
        })
    }

    const handleNextStep = () => {
        let maxSteps = 1

        if (selection?.videoPresentation) {
            maxSteps = (selection?.interviews?.length || 0) + 3
        } else {
            maxSteps = (selection?.interviews?.length || 0) + 2
        }

        if (!(choose?.offerLetter && choose.candidateOfferLetterStatus === 1)) {
            maxSteps -= 1
            if (!choose?.schedule || !Array.isArray(choose?.schedule) || choose.schedule.length === 0) {
                maxSteps -= selection?.interviews?.length
            }
        }


        if (choose?.schedule && Array.isArray(choose?.schedule)) {
            for (const schedule of choose.schedule) {
                if (schedule?.days?.length > 1) {
                    maxSteps -= 1
                }
            }
        }

        if (step < maxSteps) {
            setStep(step + 1)
        }
    }

    const setNoteData = (noteData, action) => {
        if (action === "delete") {
            Swal.fire({
                title: t('selection.deleteNoteQuestion', {title: noteData.title}),
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: t('global.yes'),
                cancelButtonText: t('global.no')
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(deleteInterviewNote(choose._id, selection?.videoPresentation ? step - 2 : step - 1, noteData))
                }
            })
        } else {
            let data = {}
            if (noteData) {
                data = {...noteData}
            }
            setNoteForm({action, data})
        }
    }

    const handleNoteSubmit = (e) => {
        e.preventDefault()
        if (!noteForm?.data?.title || !noteForm?.data?.content || !noteForm?.data?.type) {
            Swal.fire({
                icon: 'error',
                title: t('selection.noteFormError')
            });
        } else {
            if (noteForm.action === 'add') {
                dispatch(addInterviewNote(choose._id, selection?.videoPresentation ? step - 2 : step - 1, noteForm.data))
            }

            if (noteForm.action === 'edit') {
                dispatch(editInterviewNote(choose._id, selection?.videoPresentation ? step - 2 : step - 1, noteForm.data))
            }
        }
    }

    const selectNote = (id) => {
        if (selectedNotes.includes(id)) {
            setSelectedNotes(selectedNotes.filter(noteId => noteId !== id))
        } else {
            setSelectedNotes([...selectedNotes, id])
        }
    }

    const deleteMultipleNotes = () => {
        Swal.fire({
            title: t('selection.deleteMultipleNotesQuestion', {qty: selectedNotes.length}),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('global.yes'),
            cancelButtonText: t('global.no')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteMultipleInterviewNotes(choose._id, selection?.videoPresentation ? step - 2 : step - 1, selectedNotes))
            }
        })
    }

    const labelInputChange = (value) => {
        if (value.length < 51) {
            setLabelInput(value)
        }
    }

    const labelKeyDown = (e) => {
        if (labelInput) {
            switch (e.key) {
                case 'Enter':
                case 'Tab':
                    setLabelsValue([...labelsValue, {label: labelInput, value: labelInput}])
                    setLabelInput('')
                    e.preventDefault()
                    break;
                default:
                    break;
            }
        }
    }

    const saveLabels = () => {
        dispatch(registerLabels({
            school: school?._id,
            candidate: choose.candidate._id,
            labels: labelsValue.map(l => l.label)
        }))
    }

    useEffect(() => {
        if(client){
            dispatch(getSchoolBySelection(params.id))
            dispatch(getSelection(params.id))
            dispatch(getChoose(params.choose))
            dispatch(getLevels())
            dispatch(getCourseSubjects())
        }
    },[dispatch, t, client, params])

    useEffect(() => {
        if (school) {
            dispatch(getInterviewsCalendarBySchool(school._id))
            dispatch(getReducedStocksBySchool(school?._id))
        }
    }, [school, dispatch])

    useEffect(() => {
        if(result){
            dispatch({ type: 'CHOOSE_RESET_RESULT' })
            switch (result) {
                case 'dimissCandidateSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.dimiss.dimissCandidateSuccess')
                    })
                    setSelectedCandidate(null)
                    setDimissReason(null)
                    setDimissReasonDescription(null)
                    break;
                case 'successNewScheduleInterview':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.successNewScheduleInterview')
                    })
                    dispatch(getInterviewsCalendarBySchool(school._id))
                    dispatch(getChoose(params.choose))
                    setInterviewDates([])
                    setSelectedInterviewTime(null)
                    setSelectedInterviewDate(null)
                    break;
                case 'chooseSendOfferLetterSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.chooseSendOfferLetterSuccess')
                    })
                    setOfferLetterData({
                        sexualCrimeCertification: true,
                        step: 1
                    })
                    dispatch(getChoose(params.choose))
                break;
                case 'setIncorporationDateSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.setIncorporationDateSuccess')
                    })
                    dispatch(getChoose(params.choose))
                    setIncorporationDate(selection?.incorporationDate ? `${new Date(selection.incorporationDate).getFullYear()}-${String(new Date(selection.incorporationDate).getMonth() + 1).padStart(2, "0")}-${String(new Date(selection.incorporationDate).getDate()).padStart(2, "0")}` : null)
                    setIncorporationHour(null)
                    break;
                case 'successAddInterviewNote':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.successAddInterviewNote')
                    })
                    dispatch(getChoose(params.choose))
                    setNoteForm(null)
                    break
                case 'successEditInterviewNote':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.successEditInterviewNote')
                    })
                    dispatch(getChoose(params.choose))
                    setNoteForm(null)
                    break
                case 'successDeleteInterviewNote':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.successDeleteInterviewNote')
                    })
                    dispatch(getChoose(params.choose))
                    setNoteForm(null)
                    break
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    },[result, t, dispatch, school, params])

    useEffect(() => {
        if (stocksResult === "successAddFavourite" || stocksResult === "successRemoveFavourite") {
            dispatch(getReducedStocksBySchool(school?._id))
            setMultiSchoolStockForm(null)
        }
        if (stocksResult === "successAddBlocked") {
            dispatch(getReducedStocksBySchool(school?._id))
            setSelectedCandidateProfile(null)
            dispatch(getChoosesBySelection(params.id))
            setMultiSchoolStockForm(null)
        }
    }, [stocksResult, dispatch, school])

    useEffect(() => {
        if (selection) {
            setIncorporationDate(selection?.incorporationDate ? `${new Date(selection.incorporationDate).getFullYear()}-${String(new Date(selection.incorporationDate).getMonth() + 1).padStart(2, "0")}-${String(new Date(selection.incorporationDate).getDate()).padStart(2, "0")}` : null)
            dispatch(getSchoolStaffsBySchool(selection.school?._id || selection.school))
        }
    }, [selection])

    useEffect(() => {
        if (choose?.candidate) {
            dispatch(getLabelsBySelection(choose.candidate._id, params.id))
        }

        if (choose?._id) {
            let lastStep = 1
            if (choose?.schedule && choose.schedule.length > 0) {
                lastStep = selection?.videoPresentation ? selection?.interviews.length + 1 : selection?.interviews.length
            } else {
                if (selection?.videoPresentation) {
                    lastStep = 2
                }
            }

            if (selection?.interviews?.length === choose?.schedule?.length) {
                lastStep = selection?.videoPresentation ? selection?.interviews.length + 1 : selection?.interviews.length
            }

            if (choose?.offerLetter) {
                lastStep += 1

                if (choose?.candidateOfferLetterStatus === 1) {
                    lastStep += 1
                }
            }
            setStep(lastStep)
            setMaxStep(lastStep)
        }
    }, [choose, selection, dispatch, params])

    useEffect(() => {
        let index = -1
        if (selection?.videoPresentation && Number(selection?.interviews?.length || 0) + 2 > step) {
            index = step - 2
        } else if (!selection?.videoPresentation && Number(selection?.interviews?.length || 0) + 1 > step) {
            index = step - 1
        }

        if (index > -1) {
            setInterviewDates((choose?.schedule ? choose?.schedule[index] : [])?.days?.map(day => {
                return {
                    ...day,
                    date: new Date(day.date),
                    hour: day.hour || '00:00'
                }
            }) ||[])
        }
    }, [step, selection, choose])

    useEffect(() => {
        if (labels) {
            setLabelsValue(labels.map(l => {
                return { label: l, value: l}
            }))
        }
    }, [labels])

    useEffect(() => {
        if (labelsResult) {
            switch (labelsResult) {
                case 'labelEditedSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.labelEditedSuccess')
                    })
                    setLabelInput('')
                    break;
                default:
                    break;
            }
            dispatch({ type: 'LABEL_RESET_RESULT' })
        }
    }, [labelsResult, dispatch])

    const notesColumns = [
        {
            cell: note =>
                note.author === client?.id || client?.rol === 'Superadmin'
                    ?
                        <Form.Check
                            type='checkbox'
                            checked={selectedNotes.includes(note._id)}
                            onChange={() => selectNote(note._id)}
                        />
                    :
                        <></>,
            selector: (note) => note._id,
            width: '15px',
            sortable: false
        },
        {
            name: t('selection.title'),
            id: 'id',
            cell: note =>
                <div className='cursor' onClick={() => setNoteData(note, 'details')}>
                    {note.title}
                </div>,
            selector: (note) => note.title,
            sortable: true,
        },{
            name: t('selection.author'),
            cell: note =>
                <div className='cursor' onClick={() => setNoteData(note, 'details')}>
                    {schoolStaffs?.find(staff => staff.userId === note.author)?.name || school?.name}
                </div>,
            selector: (note) => note.searching,
            sortable: true,
        },{
            name: t('selection.type'),
            cell: note =>
                <div className={`cursor ${note.type === "note" ? "bg-dark-blue" : note.type === "suggestion" ? "bg-orange" : ""}`} onClick={() => setNoteData(note, 'details')}>
                    {
                        note.type === "note" || note.type === "suggestion"
                        ?
                            <Badge className='text-white' bg={note.type === "note" ? "dark-blue" : "orange"}>
                                {t('selection.' + note.type)}
                            </Badge>
                        :
                            t('selection.' + note.type)
                    }
                </div>,
            selector: (note) => note.searching,
            sortable: true,
        },{
            name: t('global.actions'),
            center: 'true',
            cell: note =>
                <Dropdown drop='start'>
                    <Dropdown.Toggle as="img" src="/images/options.svg" className='cursor muted'/>
                    <Dropdown.Menu>
                        <Dropdown.Item as="div" className='cursor' onClick={() => setNoteData(note, "details")}>
                            {t("selection.detailsNote")}
                        </Dropdown.Item>
                        {
                            note.author === client?.id || client?.rol === 'Superadmin'
                            ?
                                <>
                                    <Dropdown.Item as="div" className='cursor' onClick={() => setNoteData(note, "edit")}>
                                        {t("selection.editNote")}
                                    </Dropdown.Item>
                                    <Dropdown.Item as="div" className='cursor' onClick={() => setNoteData(note, "delete")}>
                                        {t("selection.deleteNote")}
                                    </Dropdown.Item>
                                </>
                            :
                                <></>
                        }
                    </Dropdown.Menu>
                </Dropdown>,
            selector: (note) => note.marketing,
            sortable: true,
        }
    ]

    return (
        <>
            <Container className='cuerpo'>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra lateral'>
                            <Card.Body className='p-5'>
                                <div className='mb-3'>
                                    <Link to={`/${client?.rol === 'MultiSchool' ? 'multischool' : 'School'}/overviewprocess/${params.id}/candidates`} className='link-dark'>
                                        <div className='py-3 d-flex align-items-center'>
                                            <img src="/images/left-arrow.svg" alt="Flecha izquierda" />
                                            <h3 className='ms-3 m-0'>{t("selection.teacherProfile")}</h3>
                                        </div>
                                    </Link>
                                </div>
                                <div className='d-flex justify-content-between align-items-center border-bottom pb-4'>
                                    <h2 className='color-primary'>{choose?.candidate?.firstname} {choose?.candidate?.lastname}</h2>
                                    <div className='d-flex gap-2 profile-icons'>
                                        <Badge className={`porcentaje ${choose?.porcentage > 85 ? 'bg-high' : (choose?.porcentage >= 60 ? 'bg-medium' : 'bg-low')}`}>
                                            {choose?.porcentage}%
                                        </Badge>
                                        {
                                            stocks?.some(stock => stock.candidate === selectedCandidateProfile?.candidate?._id && stock?.type.includes("favourite"))
                                            ?
                                                <img src='/images/favourite.svg' alt='Favorito' className='normal-with-hover cursor' onClick={() => handleEditStock(choose?.candidate, 'removeFavourite')} />
                                            :
                                                <img src='/images/favourite.svg' alt='Favorito' className='grey-with-hover cursor' onClick={() => handleEditStock(choose?.candidate, 'addFavourite')} />
                                        }
                                        {
                                            selection?.videoPresentation
                                            ?
                                                choose?.videoSaw
                                                ?
                                                    <img src="/images/video-viewed.svg" alt='Vídeo' className='cursor' onClick={() => {handleVideoClick(choose)}}/>
                                                :
                                                    <img src="/images/video.svg" alt='Vídeo' className={choose?.videoPresentation ? 'cursor' : 'muted'} onClick={() => {handleVideoClick(choose)}}/>
                                            :
                                                <></>
                                        }
                                        {
                                            choose?.candidate?.curriculumUrl
                                            ?
                                                <a href={choose.candidate.curriculumUrl} target='_blank' rel='noreferrer'>
                                                    <img src="/images/download.svg" alt='Curriculum' className='cursor muted-no-hover' />
                                                </a>
                                            :
                                                <></>
                                        }
                                        <img src='/images/message-report.svg' alt='Reportar' className='cursor' onClick={() => handleReportModalShow(choose?.user?._id)}/>
                                        <img src='/images/block.svg' alt='Bloquear' className="grey-with-hover cursor" onClick={() => {handleEditStock(choose?.candidate, 'addBlocked')}} />
                                    </div>
                                </div>
                                <div className='d-lg-flex d-block border-bottom pb-4 align-items-center mt-4 align-items-center candidate-header'>
                                    <div className="mb-4 mb-lg-0">
                                        <div className='border-md-end candidate pe-4 d-flex justify-content-center'>
                                            <div className='avatar-mini'>
                                                {choose?.user?.image
                                                    ?
                                                        <img className="img-profile" alt="Preview" src={typeof choose?.user?.image === 'string' ? choose?.user?.image : URL.createObjectURL(choose?.user?.image)} />
                                                    :
                                                        <img className='img-profile' alt="Avatar" src="/images/avatar-empty.svg" />
                                                }
                                                {
                                                    (selectedCandidate?.currentSelections && selectedCandidate?.currentSelections > 0 ? true : false) &&
                                                        <Badge bg='danger' className='number-info' title={t('candidate.numberSelection')}>{selectedCandidate.currentSelections}</Badge>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <Container>
                                        <Row className='ms-md-3 align-items-center'>
                                            <Col xs={12} lg={6} className='mb-3 border-md-end'>
                                                <h3 className='fw-bold'>{selection?.title}</h3>
                                                <Row className='border-bottom pb-2'>
                                                    <Col xs={3} className='fs-4'>{t('selection.labels')}:</Col>
                                                    <Col xs={8}>
                                                        <CreatableSelect
                                                            isMulti
                                                            menuIsOpen={false}
                                                            components={{DropdownIndicator: null}}
                                                            onKeyDown={labelKeyDown}
                                                            onInputChange={labelInputChange}
                                                            onChange={value => setLabelsValue(value)}
                                                            inputValue={labelInput}
                                                            value={labelsValue}
                                                        />
                                                        <span className='text-muted fs-6'><small>{t('selection.labelsDescription', {qty: labelInput.length})}</small></span>
                                                    </Col>
                                                    <Col xs={1}>
                                                        <Button variant='primary' className='mt-1 p-0' type='button' onClick={saveLabels} disabled={labelsLoading}>
                                                            {
                                                                labelsLoading
                                                                ?
                                                                    <span className="spinner-border spinner-border-sm align-middle p-2"/>
                                                                :
                                                                    <i className='fas fa-floppy-disk p-2'/>
                                                            }
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <Row className='align-items-center justify-content-around pt-3'>
                                                    <Col className='d-flex justify-content-center'>
                                                        <div className='d-flex align-items-center gap-2 fw-bold text-muted text-break'>
                                                            <img src='/images/envelope.svg' alt='email'/>
                                                            {choose?.user?.email}
                                                        </div>
                                                    </Col>
                                                    {
                                                        choose?.candidate?.phone
                                                        ?
                                                            <Col className='d-flex justify-content-center'>
                                                                <div className='d-flex align-items-center gap-2 fw-bold text-muted text-break'>
                                                                    <img src='/images/phone.svg' alt='phone'/>
                                                                    {choose?.candidate?.phone}
                                                                </div>
                                                            </Col>
                                                        :
                                                            <></>
                                                    }
                                                </Row>
                                            </Col>
                                            <Col xs={12} lg={6} className='mb-3'>
                                                {
                                                    towns?.find(p => p.value === choose?.candidate?.town)
                                                    ?
                                                        <div className='d-flex justify-content-between text-muted m-2'>
                                                            <span>{t("users.town")}</span>
                                                            <span className='fw-bold'>{towns?.find(p => p.value === choose?.candidate?.town)?.label}</span>
                                                        </div>
                                                    :
                                                        <></>
                                                }
                                                {
                                                    provinces?.find(p => p.value === choose?.candidate?.province)
                                                    ?
                                                        <div className='d-flex justify-content-between text-muted m-2'>
                                                            <span>{t("users.province")}</span>
                                                            <span className='fw-bold'>{provinces?.find(p => p.value === choose?.candidate?.province)?.label}</span>
                                                        </div>
                                                    :
                                                        <></>
                                                }
                                                <div className='d-flex justify-content-between text-muted m-2'>
                                                    <span>{t("config.candidate.profile")}</span>
                                                    <span className='fw-bold color-primary text-decoration-underline cursor' onClick={() => setSelectedCandidateProfile(choose)}>{t("selection.watchProfile")}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                                <Row className='mt-3'>
                                    <Col xs={4} className='p-4'>
                                        <div className='fs-4 mb-4'>{t("selection.history")}:</div>
                                        {
                                            selection?.videoPresentation
                                            ?
                                                <div className='d-flex gap-2 mb-1'>
                                                    <div>
                                                        <div className={`rounded-circle ${step === 1 ? 'bg-primary' : step > 1 ? 'bg-green cursor' : maxStep >= 1 ? 'bg-green cursor' : 'bg-muted'} selection-status me-2`} onClick={() => {
                                                            if (maxStep >= 1) {
                                                                setStep(1)
                                                            }
                                                        }}>
                                                            {
                                                                choose?.videoPresentation
                                                                ?
                                                                    <img src='/images/check-white.svg' alt='Hecho'/>
                                                                :
                                                                    <></>
                                                            }
                                                        </div>
                                                        <div className={`step-connector-vertical mt-1 ${step > 1 || (maxStep > 2 && choose?.schedule?.length > 0) ? 'bg-green' : 'bg-muted'}`}/>
                                                    </div>
                                                    <div>
                                                        <div>{t("selection.faseNumber", {number: 1}).toLocaleUpperCase()}</div>
                                                        <div className={step === 1 ? 'color-primary' : step > 1 ? 'text-green' : 'text-muted'}>{t("school.selection.video")}</div>
                                                    </div>
                                                </div>
                                            :
                                                <></>
                                        }
                                        {
                                            selection?.interviews?.map((interview, index) => (
                                                <div className='d-flex gap-2 mb-1' key={index}>
                                                    <div>
                                                        <div className={`rounded-circle ${index === 0 || (selection?.videoPresentation && (step > index + 2 || maxStep >= index + 2)) || (step > index + 1 || maxStep >= index + 1) ? 'cursor' :''} ${selection?.videoPresentation ? step === index + 2 ? 'bg-primary' : step > index + 2 || maxStep >= index + 2 ? 'bg-green' : 'bg-muted' : step === index + 1 ? 'bg-primary' : step > index + 1 || maxStep >= index + 1 ? 'bg-green' : `bg-muted ${index === 0 || selection.interviews[index - 1].days?.length === 1 ? 'cursor' : ''}`} selection-status me-2`} onClick={() => {
                                                            if (index === 0 || choose.schedule[index]?.days?.length === 1) {
                                                                if (selection?.videoPresentation){
                                                                    if (maxStep >= index + 2) {
                                                                        setStep(index + 2)
                                                                    }
                                                                } else {
                                                                    if (maxStep >= index + 1) {
                                                                        setStep(index + 1)
                                                                    }
                                                                }
                                                            }
                                                        }}>
                                                            {
                                                                choose?.schedule && choose.schedule[index]?.days?.length === 1
                                                                ?
                                                                    choose.schedule[index]?.notes?.length > 0
                                                                    ?
                                                                        <i className='mt-1 fas fa-envelope fa-xs text-white'/>
                                                                    :
                                                                        <img src='/images/check-white.svg' alt='Hecho'/>
                                                                :
                                                                    <></>
                                                            }
                                                        </div>
                                                        <div className={`step-connector-vertical mt-1 ${selection?.videoPresentation ? step > index + 2 || maxStep > index + 2 ? 'bg-green' : 'bg-muted' : step > index + 1 || maxStep > index + 1 ? 'bg-green' : 'bg-muted'}`}/>
                                                    </div>
                                                    <div>
                                                        <div>{t("selection.faseNumber", {number: selection?.videoPresentation ? index + 2 : index + 1}).toLocaleUpperCase()}</div>
                                                        <div className={selection?.videoPresentation ? step === index + 2 ? 'color-primary' : step > index + 2 || maxStep >= index + 2 ? 'text-green' : 'text-muted' : step === index + 1 ? 'color-primary' : step > index + 1 || maxStep >= index + 1 ? 'text-green' : 'text-muted'}>{t("selection.interview")} {index + 1}</div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                        <div className='d-flex gap-2 mb-1'>
                                            <div>
                                                <div className={`rounded-circle cursor ${selection?.videoPresentation ? step === (selection?.interviews?.length || 0) + 2 ? 'bg-primary' : step > (selection?.interviews?.length || 0) + 2 || maxStep >= (selection?.interviews?.length || 0) + 2 ? 'bg-green' : 'bg-muted' : step === (selection?.interviews?.length || 0) + 1 ? 'bg-primary' : step > (selection?.interviews?.length || 0) + 1 || maxStep >= (selection?.interviews?.length || 0) + 1 ? 'bg-green' : 'bg-muted'} selection-status me-2`} onClick={() => {
                                                    if (selection?.videoPresentation) {
                                                        setStep((selection?.interviews?.length || 0) + 2)
                                                    } else {
                                                        setStep((selection?.interviews?.length || 0) + 1)
                                                    }
                                                }}>
                                                    {
                                                        choose?.offerLetter
                                                        ?
                                                            <img src='/images/check-white.svg' alt='Hecho'/>
                                                        :
                                                            <></>
                                                    }
                                                </div>
                                                <div className={`step-connector-vertical mt-1 ${selection?.videoPresentation ? step > (selection?.interviews?.length || 0) + 2 || maxStep > (selection?.interviews?.length || 0) + 2 ? 'bg-green' : 'bg-muted' : step > (selection?.interviews?.length || 0) + 1 || maxStep > (selection?.interviews?.length || 0) + 1 ? 'bg-green' : 'bg-muted'}`}/>
                                            </div>
                                            <div>
                                                <div>{t("selection.faseNumber", {number: selection?.videoPresentation ? (selection?.interviews?.length || 0) + 2 : (selection?.interviews?.length || 0) + 1}).toLocaleUpperCase()}</div>
                                                <div className={selection?.videoPresentation ? step === (selection?.interviews?.length || 0) + 2 ? 'color-primary' : step > (selection?.interviews?.length || 0) + 2 || maxStep >= (selection?.interviews?.length || 0) + 2 ? 'text-green' : 'text-muted' : step === (selection?.interviews?.length || 0) + 1 ? 'color-primary' : step > (selection?.interviews?.length || 0) + 1 || maxStep >= (selection?.interviews?.length || 0) + 1 ? 'text-green' : 'text-muted'}>{t("selection.offerLetter")}</div>
                                            </div>
                                        </div>
                                        <div className='d-flex gap-2'>
                                            <div>
                                                <div className={`rounded-circle ${selection?.videoPresentation ? step === (selection?.interviews?.length || 0) + 3 ? 'bg-primary' : step > (selection?.interviews?.length || 0) + 3 || maxStep >= (selection?.interviews?.length || 0) + 3 ? 'bg-green cursor' : `bg-muted ${choose?.offerLetter && choose.candidateOfferLetterStatus === 1 ? 'cursor' : ''}` : step === (selection?.interviews?.length || 0) + 2 ? 'bg-primary' : step > (selection?.interviews?.length || 0) + 2 || maxStep >= (selection?.interviews?.length || 0) + 2 ? 'bg-green cursor' : `bg-muted ${choose?.offerLetter && choose.candidateOfferLetterStatus === 1 ? 'cursor' : ''}`} selection-status me-2`} onClick={() => {
                                                    if (choose?.offerLetter && choose.candidateOfferLetterStatus === 1){
                                                        if (selection?.videoPresentation) {
                                                            setStep((selection?.interviews?.length || 0) + 3)
                                                        } else {
                                                            setStep((selection?.interviews?.length || 0) + 2)
                                                        }
                                                    }
                                                }}>
                                                    {
                                                        choose?.incorporationDate?.date
                                                        ?
                                                            <img src='/images/check-white.svg' alt='Hecho'/>
                                                        :
                                                            <></>
                                                    }
                                                </div>
                                            </div>
                                            <div>
                                                <div>{t("selection.faseNumber", {number: selection?.videoPresentation ? (selection?.interviews?.length || 0) + 3 : (selection?.interviews?.length || 0) + 2}).toLocaleUpperCase()}</div>
                                                <div className={selection?.videoPresentation ? step === (selection?.interviews?.length || 0) + 3 ? 'color-primary' : step > (selection?.interviews?.length || 0) + 3 || maxStep >= (selection?.interviews?.length || 0) + 3 ? 'text-green' : 'text-muted' : step === (selection?.interviews?.length || 0) + 2 ? 'color-primary' : step > (selection?.interviews?.length || 0) + 2 || maxStep >= (selection?.interviews?.length || 0) + 2 ? 'text-green' : 'text-muted'}>{t("selection.schoolIncorporation")}</div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={8} className='p-4 bg-dark-grey rounded'>
                                        <h4>{t("selection.faseNumber", {number: step}).toLocaleUpperCase()}</h4>
                                        {
                                            selection?.videoPresentation && step === 1
                                            ?
                                                <>
                                                    <h3>{t("school.selection.video")}</h3>
                                                    {
                                                        choose?.videoPresentation
                                                        ?
                                                            <video src={choose?.videoPresentation} controls className='w-100'/>
                                                        :
                                                            <span>{t("selection.noVideo")}</span>
                                                    }
                                                </>
                                            :
                                                <></>
                                        }
                                        {
                                            (selection?.videoPresentation && step > 1 && step - 1 < selection?.interviews?.length + 1) || (!selection?.videoPresentation && step <= selection?.interviews?.length)
                                            ?
                                                <>
                                                    {
                                                        !choose?.schedule[selection?.videoPresentation ? step - 2 : step - 1]?.days || choose?.schedule[selection?.videoPresentation ? step - 2 : step - 1]?.days?.length !== 1
                                                        ?
                                                            <div>
                                                                <h3>{t("selection.interview")} {selection?.videoPresentation ? step - 1 : step}</h3>
                                                                <h4 className='mb-4 text-center'>{t('selection.propose3Dates')}</h4>
                                                                {
                                                                    choose?.schedule[selection?.videoPresentation ? step - 2 : step - 1]?.comment &&
                                                                    <div className='mt-3'>
                                                                        <div className='fw-bold'>{t("selection.candidateComment")}</div>
                                                                        {choose?.schedule[selection?.videoPresentation ? step - 2 : step - 1]?.comment.split("\n").map((paragraph, index) => (
                                                                            <p key={index}>{paragraph}</p>
                                                                        ))}
                                                                    </div>
                                                                }
                                                                <div className='bg-white p-3 rounded'>
                                                                    <FullCalendar
                                                                        displayEventTime={false}
                                                                        ref={calendar}
                                                                        height={'auto'}
                                                                        fixedWeekCount={false}
                                                                        locale={esLocale}
                                                                        weekends={true}
                                                                        plugins={[dayGridPlugin, interactionPlugin]}
                                                                        headerToolbar={{
                                                                            start: 'prev',
                                                                            center: 'title',
                                                                            end: 'next',
                                                                        }}
                                                                        dateClick={handleInterviewDateClick}
                                                                        events={(schedule?.map(s => {
                                                                                if(s.choose._id === choose?._id) {
                                                                                    return null
                                                                                } else {
                                                                                    let eventDate = new Date(s.day)
                                                                                    eventDate.setHours(s.hour?.split(':')[0])
                                                                                    eventDate.setMinutes(s.hour?.split(':')[1])
                                                                                    return {...s, title: `${s.candidate} (${s.hour})`, start: eventDate, classNames: ['text-body'], color: s.accepted ? 'green' : 'orange'}
                                                                                }
                                                                            }) || [])?.concat(choose?.schedule.map((schedule, scheduleIndex) => {
                                                                                let accepted = schedule.days.length === 1
                                                                                return schedule.days.map((e, eIndex) => {
                                                                                    let eventDate = new Date(e.date)
                                                                                    eventDate.setHours(e.hour?.split(':')[0])
                                                                                    eventDate.setMinutes(e.hour?.split(':')[1])
                                                                                    if((selection?.videoPresentation && scheduleIndex !== step - 2) || (!selection?.videoPresentation && scheduleIndex !== step - 1)) {
                                                                                        return {...e, selection: {...selection}, chooseData: {...choose}, title: `${choose.candidate.firstname} ${choose.candidate.lastname} (${e.hour})`, start: eventDate, classNames: ['text-body'], color: accepted ? 'green' : 'orange'}
                                                                                    } else {
                                                                                        return null
                                                                                    }
                                                                                })
                                                                            }) ||[])?.concat(interviewDates?.map((d, dIndex) => {
                                                                                let eventDate = d.date
                                                                                eventDate.setHours(d.hour?.split(':')[0])
                                                                                eventDate.setMinutes(d.hour?.split(':')[1])
                                                                                return {title: `${choose.candidate.firstname} ${choose.candidate.lastname} (${d.hour})`, start: eventDate, classNames: ['text-body'], type: 'choose', index: dIndex}
                                                                            }) || [])?.flat(Infinity)?.filter(s => s !== null)}
                                                                        eventClick={handleEventClick}
                                                                    />
                                                                </div>
                                                                <Row className='my-3'>
                                                                    <Col className='d-flex justify-content-end'>
                                                                        <Button variant='primary' onClick={handleInterviewSave}>{t('global.save')}</Button>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        :
                                                            <>
                                                                <div className='d-flex align-items-end justify-content-between mb-3'>
                                                                {/* <div> */}
                                                                    <h3>{t("selection.interview")} {selection?.videoPresentation ? step - 1 : step}</h3>
                                                                    <Button variant="primary" type="button" onClick={() => setIsMeetingVisible(true)}>{t("selection.openMeeting")}</Button>
                                                                </div>
                                                                <div className='d-flex align-items-end justify-content-between mb-3'>
                                                                    <h3>{t("selection.notes")}</h3>
                                                                    <div className='d-flex gap-2'>
                                                                        {
                                                                            selectedNotes.length > 0
                                                                            ?
                                                                                <Button variant="grey" type="button" className='d-flex align-items-center gap-2' onClick={deleteMultipleNotes}>
                                                                                    <img src="/images/trash-grey.svg" alt={t("selection.deleteNotes")}/>
                                                                                    {t("selection.deleteNotes")}
                                                                                </Button>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        <Button variant="grey" type="button" className='d-flex align-items-center gap-2' onClick={() => setNoteData({}, "add")}>
                                                                            <img src="/images/add.svg" alt={t("selection.newNote")}/>
                                                                            {t("selection.newNote")}
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    choose?.schedule[selection?.videoPresentation ? step - 2 : step - 1]?.notes && choose?.schedule[selection?.videoPresentation ? step - 2 : step - 1]?.notes?.length > 0
                                                                    ?
                                                                        <div className='mt-5'>
                                                                            <CustomDataTable columns={notesColumns} data={choose?.schedule[selection?.videoPresentation ? step - 2 : step - 1]?.notes} />
                                                                        </div>
                                                                    :
                                                                        <div className='mt-5'>
                                                                            {t('selection.noNotes')}
                                                                        </div>
                                                                }
                                                            </>
                                                    }
                                                </>
                                            :
                                                <></>
                                        }
                                        {
                                            (selection?.videoPresentation && step === (selection?.interviews?.length || 0) + 2) || (!selection?.videoPresentation && step === (selection?.interviews?.length || 0) + 1)
                                            ?
                                                <div className='mt-5 bg-white p-4 rounded'>
                                                    {
                                                        !choose?.offerLetter
                                                        ?
                                                            <h5 className='mb-3'>{t("selection.offerLetterStep", {current: offerLetterData.step, total: 3})}</h5>
                                                        :
                                                            <></>
                                                    }
                                                    {
                                                        !choose?.offerLetter && offerLetterData.step === 1 &&
                                                        <>
                                                            <div>
                                                                {t('selection.candidateOfferLetterQuestion', {name: `${choose?.candidate?.firstname} ${choose?.candidate?.lastname}`})}
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.dni')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="dni"
                                                                    id="dni"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.dni}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.socialSecurity')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="socialSecurity"
                                                                    id="socialSecurity"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.socialSecurity}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.bankAccount')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="bankAccount"
                                                                    id="bankAccount"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.bankAccount}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.photo')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="photo"
                                                                    id="photo"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.photo}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.foodHandlingCard')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="foodHandlingCard"
                                                                    id="foodHandlingCard"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.foodHandlingCard}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.sexualCrimeCertification')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="sexualCrimeCertification"
                                                                    id="sexualCrimeCertification"
                                                                    readOnly
                                                                    checked={offerLetterData.sexualCrimeCertification}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.workResidencyPermission')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="workResidencyPermission"
                                                                    id="workResidencyPermission"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.workResidencyPermission}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.workLifeReport')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="workLifeReport"
                                                                    id="workLifeReport"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.workLifeReport}
                                                                />
                                                            </div>
                                                            <div className='my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.others')}</Form.Label>
                                                                <Form.Control
                                                                    className="me-3"
                                                                    as="textarea"
                                                                    name="otherDocumentation"
                                                                    id="otherDocumentation"
                                                                    onChange={handleOfferLetterChange}
                                                                    value={offerLetterData.otherDocumentation}
                                                                />
                                                            </div>
                                                        </>
                                                    }
                                                    {
                                                        !choose?.offerLetter && offerLetterData.step === 2 &&
                                                        <>
                                                            <div>
                                                                {t('selection.candidateOfferLetterBenefits', {name: `${choose?.candidate?.firstname} ${choose?.candidate?.lastname}`})}
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.lifeOrAccidentsInsurance')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="lifeOrAccidentsInsurance"
                                                                    id="lifeOrAccidentsInsurance"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.lifeOrAccidentsInsurance}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.continuousFormation')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="continuousFormation"
                                                                    id="continuousFormation"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.continuousFormation}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.privateMedicalInsurance')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="privateMedicalInsurance"
                                                                    id="privateMedicalInsurance"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.privateMedicalInsurance}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.foodDiscounts')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="foodDiscounts"
                                                                    id="foodDiscounts"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.foodDiscounts}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.emotionalWelfarePrograms')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="emotionalWelfarePrograms"
                                                                    id="emotionalWelfarePrograms"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.emotionalWelfarePrograms}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.schoolDiscounts')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="schoolDiscounts"
                                                                    id="schoolDiscounts"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.schoolDiscounts}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.sportsFacilitiesDiscounts')}</Form.Label>
                                                                <Form.Check
                                                                    className="me-3"
                                                                    type="switch"
                                                                    name="sportsFacilitiesDiscounts"
                                                                    id="sportsFacilitiesDiscounts"
                                                                    onChange={handleOfferLetterSwitchChange}
                                                                    checked={offerLetterData.sportsFacilitiesDiscounts}
                                                                />
                                                            </div>
                                                            <div className='my-3'>
                                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.others')}</Form.Label>
                                                                <Form.Control
                                                                    className="me-3"
                                                                    as="textarea"
                                                                    name="otherBenefits"
                                                                    id="otherBenefits"
                                                                    onChange={handleOfferLetterChange}
                                                                    value={offerLetterData.otherBenefits}
                                                                />
                                                            </div>
                                                        </>
                                                    }
                                                    {
                                                        (choose?.offerLetter || offerLetterData?.step === 3) &&
                                                        <>
                                                            <div style={{height: "70vh"}}>
                                                                <PDFViewer
                                                                    children={<OfferLetter selection={selection} choose={{...choose, offerLetter: choose?.offerLetter || offerLetterData}} school={{...school, image: schooluser?.image}}/>}
                                                                    style={{width: "100%", height: "100%"}}
                                                                />
                                                            </div>
                                                        </>
                                                    }
                                                    {
                                                        !choose?.offerLetter
                                                        ?
                                                            <Row className='my-3'>
                                                                <Col className='d-flex justify-content-end'>
                                                                    {
                                                                        offerLetterData.step > 2
                                                                        ?
                                                                            <Button variant='primary' onClick={handleSendOfferLetter}>
                                                                                {
                                                                                    loading
                                                                                    ?
                                                                                        <span className="spinner-border spinner-border-sm align-middle ms-2"/>
                                                                                    :
                                                                                        t("global.save")
                                                                                }
                                                                            </Button>
                                                                        :
                                                                            <Button variant='primary' onClick={() => handleOfferLetterChange({target: {name: "step", value: offerLetterData.step + 1}})}>
                                                                                {t("global.next")}
                                                                            </Button>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        :
                                                        <></>
                                                    }
                                                </div>
                                            :
                                            <></>
                                        }
                                        {
                                            (selection?.videoPresentation && step === (selection?.interviews?.length || 0) + 3) || (!selection?.videoPresentation && step === (selection?.interviews?.length || 0) + 2)
                                                ?
                                                    choose?.incorporationDate
                                                    ?
                                                        <>
                                                        <div className='bg-white p-4 rounded'>
                                                            <h3>{t('selection.submenu.incorporationDate')}</h3>
                                                            {`${new Date(choose?.incorporationDate?.date).toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric'})} ${choose?.incorporationDate?.hour || ''}`}
                                                        </div>
                                                        </>
                                                    :
                                                        <>
                                                            <h3>{t('selection.setIncorporationDate', {name: `${choose?.candidate?.firstname} ${choose?.candidate?.lastname}`})}</h3>
                                                            <div className='bg-white p-4 rounded'>
                                                                <div className='my-3'>
                                                                    <Form.Label>{t("selection.incorporationDate")}</Form.Label>
                                                                    <Form.Control type='date' value={incorporationDate || ""} onChange={({target}) => setIncorporationDate(target.value)}/>
                                                                    {
                                                                        incorporationDate && new Date(incorporationDate).getTime() < new Date().getTime()
                                                                        ?
                                                                            <div className='text-danger mt-2'>{t("selection.incorporationDateWarning")}</div>
                                                                        :
                                                                            <></>
                                                                    }
                                                                </div>
                                                                <div className='my-3'>
                                                                    <Form.Label>{t("selection.incorporationHour")}</Form.Label>
                                                                    <Form.Control type='time' value={incorporationHour || ""} onChange={({target}) => setIncorporationHour(target.value)}/>
                                                                </div>
                                                                <Row className='my-3'>
                                                                    <Col className='d-flex justify-content-end'>
                                                                        <Button variant='primary' onClick={handleSetIncorporationDate}>
                                                                            {
                                                                                loading
                                                                                ?
                                                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"/>
                                                                                :
                                                                                    t("global.save")
                                                                            }
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </>
                                                :
                                                    <></>
                                        }
                                    </Col>
                                </Row>
                                    {
                                        !choose?.incorporationDate?.date
                                        ?
                                            <div className='d-flex gap-2 justify-content-end mt-5'>
                                                <Button variant='info' onClick={() => setSelectedCandidate(choose)}><span className="px-4">{t("selection.dimissCandidate")}</span></Button>
                                                <Button variant='primary' onClick={handleNextStep}>{t("selection.nextStep")}</Button>
                                            </div>
                                        :
                                            <></>
                                    }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal size='lg' show={selectedCandidate ? true : false} onHide={onModalClose} >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("selection.candidateDimissTitle", {name: `${selectedCandidate?.candidate?.firstname} ${selectedCandidate?.candidate?.lastname}`})}
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='my-3'>
                        <Form.Label>{t("selection.dimissReason")}</Form.Label>
                        <Form.Select value={dimissReason || "null"} onChange={({target}) => setDimissReason(target.value)}>
                            <option value="null" disabled>{t("global.selectOption")}</option>
                            {["noRequisites", "noCulture", "chooseAnotherOne", "genericDimiss"].map((reason, index) => (
                                <option value={reason} key={index}>{t("selection.dimiss." + reason)}</option>
                            ))}
                        </Form.Select>
                    </div>
                    {
                        dimissReason &&
                        <div className='my-3'>
                            <Form.Label>{t("selection.dimissReason")}</Form.Label>
                            <Form.Control as="textarea" value={dimissReasonDescription || t("selection.dimiss." + dimissReason + "Description", {name: `${selectedCandidate?.candidate?.firstname} ${selectedCandidate?.candidate?.lastname}`})} onChange={({target}) => setDimissReasonDescription(target.value)} rows={6}/>
                        </div>
                    }
                    <div className='my-3'>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onModalClose}>{t("global.cancel")}</Button>
                    <Button variant="primary" onClick={handleDimissSubmit}>
                        {
                            loading
                            ?
                                <span className="spinner-border spinner-border-sm align-middle ms-2"/>
                            :
                                t("global.save")
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal size='xl'show={selectedVideo ? true : false} onHide={() => setSelectedVideo(null)}>
                <Modal.Header closeButton />
                <Modal.Body>
                    {
                        selectedVideo?.videoPresentation &&
                        <video src={selectedVideo.videoPresentation} controls className='w-100'/>
                    }
                </Modal.Body>
            </Modal>
            <Modal centered={true} show={selectedInterviewDate ? true : false} onHide={closeInterviewDate}>
                <Modal.Header closeButton>
                        {
                            selectedInterviewDate
                            ?
                                <h4>
                                    {new Intl.DateTimeFormat('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(selectedInterviewDate.date)}
                                </h4>
                            :
                                ''
                        }
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>{t("dashboard.candidate.hour")}</Form.Label>
                    <Form.Control type='time' value={selectedInterviewTime || ''} onChange={({target}) => setSelectedInterviewTime(target.value)}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' type='button' onClick={closeInterviewDate}>{t('global.cancel')}</Button>
                    <Button variant='primary' type='button' onClick={saveInterviewDate}>{t('global.save')}</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={selectedEvent ? true : false} onHide={() => setSelectedEvent(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        { selectedEvent?.choose ? selectedEvent?.choose?.selection?.title : selectedEvent?.selection?.title }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("school.selection.candidate")}
                            <small>{selectedEvent?.choose ? selectedEvent?.choose?.candidate?.firstname || '' : selectedEvent?.chooseData?.candidate?.firstname || ''} {selectedEvent?.choose ? selectedEvent?.choose?.candidate?.lastname || '' : selectedEvent?.chooseData?.candidate?.lastname || ''}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("school.selection.datetime")}
                            <small>{selectedEvent?.day ? new Date(selectedEvent?.day).toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric'}) : ''} {selectedEvent?.hour || ''}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.specialty")}
                            <small>{capitalizeFirstCharacter(levels?.find(l => l.id === (selectedEvent?.selection ? selectedEvent?.selection?.specialty : selectedEvent?.selection?.specialty))?.label)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t(selectedEvent?.choose?.selection?.specialty == 1 ? "profile.candidate.position" : "selection.subject")}
                            <small>{t("subjects." + subjects?.find(s => s.id === (selectedEvent?.selection ? selectedEvent?.selection?.subject : selectedEvent?.selection?.subject))?.label)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.shortIncorporationDate")}
                            <small>{selectedEvent?.choose ? `${String(new Date(selectedEvent?.choose?.selection?.incorporationDate).getDate()).padStart(2, '0')}/${String(new Date(selectedEvent?.choose?.selection?.incorporationDate).getMonth() + 1).padStart(2, '0')}/${new Date(selectedEvent?.choose?.selection?.incorporationDate).getFullYear()}` : `${String(new Date(selectedEvent?.selection?.incorporationDate).getDate()).padStart(2, '0')}/${String(new Date(selectedEvent?.selection?.incorporationDate).getMonth() + 1).padStart(2, '0')}/${new Date(selectedEvent?.selection?.incorporationDate).getFullYear()}`}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.salary")}
                            <small>{(selectedEvent?.choose ? selectedEvent?.choose?.selection?.salary : selectedEvent?.selection?.salary) || t("selection.byAgreement")}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.contractType")}
                            <small>{t("profile.candidate." + (selectedEvent?.choose ? selectedEvent?.choose?.selection?.contractType : selectedEvent?.selection?.contractType))}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("profile.candidate.idealPosition.workDay.label")}
                            <small>{t("profile.candidate.idealPosition.workDay." + (selectedEvent?.choose ? selectedEvent?.choose?.selection?.workdayType : selectedEvent?.selection?.workdayType))}</small>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={selectedCandidateProfile ? true : false} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title" centered>
                <Modal.Header>
                    <Modal.Title id="example-custom-modal-styling-title" className='w-100 d-flex justify-content-end'>
                        <div>
                            <i className='fa fa-times cursor' onClick={() => setSelectedCandidateProfile(null)}></i>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CandidateProfile candidateToShow={{iduser: selectedCandidateProfile?.user?._id}} affinity={selectedCandidateProfile?.porcentage} actions={{favourite: handleEditStock, block: selectedCandidateProfile?.type === 'archive' ? handleEditStock : null, add: () => {if(!chooses?.find(c => c.candidate === selectedCandidateProfile?.candidate._id)){addCandidate(selectedCandidateProfile?.candidate)}}}} favourite={stocks.some(stock => stock.candidate === selectedCandidateProfile?.candidate?._id && stock.type.includes("favourite")) ? true : false} selectedCandidate={selectedCandidateProfile} selection={params.id}/>
                </Modal.Body>
                {
                    selectedCandidateProfile?.type === 'archive' &&
                    <Modal.Footer>
                        <div>
                            <Button
                                variant='success'
                                className='d-flex align-items-center justify-content-center flex-grow-1 ms-2'
                                onClick={() => {
                                    if(selectedCandidateProfile?.type === 'archive'){
                                        addCandidate(selectedCandidateProfile)}
                                    }
                                }
                            >
                                <img src='/images/plus-white.svg' alt='Añadir' className='me-2'/>
                                {t('global.add')}
                            </Button>
                        </div>
                    </Modal.Footer>
                }
            </Modal>
            <Modal size='lg' show={multiSchoolStockForm ? true : false} aria-labelledby="example-custom-modal-styling-title" onHide={handleCloseStockModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("database." + (multiSchoolStockForm?.typeStock === "favourite" ? "addFavourite" : "addBlock"))}
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleStockSubmit}>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>{t('database.blockedScope')}</Form.Label>
                            <Form.Select
                                className='mb-2'
                                value={multiSchoolStockForm?.scope}
                                onChange={(e) => {
                                    setMultiSchoolStockForm({
                                        ...multiSchoolStockForm,
                                        scope: e.target.value
                                    })
                                }}
                            >
                                <option value="all">{t('database.allSchools')}</option>
                                <option value="current">{t('database.currentSchool', {school: school?.name})}</option>
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type='button' className='btn btn-secondary' onClick={handleCloseStockModal}>
                            {t('global.cancel')}
                        </button>
                        <button className='btn btn-primary' type='submit'>
                            {t('global.save')}
                        </button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <Modal show={showReportModal} onHide={handleReportModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('report.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="reportReason">
                            <Form.Label>{t('report.reason')}</Form.Label>
                            {['accreditations', 'homologation', 'personaldata', 'inappropriatelanguage', 'inappropriatephoto', 'notrespond', 'inappropriatephotoaccreditations', 'others'].map((option, index) => (
                                <Form.Check
                                    id={`checkbox-${option}`}
                                    type="checkbox"
                                    label={t(`report.${option}`)}
                                    key={index}
                                    checked={selectedOptions?.includes(option)}
                                    onChange={(e) => handleCheckChange(e, option)}
                                />
                            ))}
                        </Form.Group>
                        <Form.Group controlId="additionalComments" className="mt-3">
                            <Form.Label>{t('report.additionalComments')}</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                onChange={(e) => setAdditionalComments(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleReportModalClose}>
                        {t('global.cancel')}
                    </Button>
                    <Button variant="primary" onClick={handleReportSubmit}>
                        {t('report.sendreport')}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={noteForm ? true : false} onHide={() => setNoteForm(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("selection." + noteForm?.action + "Note")}
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleNoteSubmit}>
                    <Modal.Body>
                            <Form.Group className='mb-3'>
                                <Form.Label>{t("selection.title")}</Form.Label>
                                <Form.Control
                                    type='text'
                                    name='title'
                                    value={noteForm?.data?.title || ''}
                                    onChange={({target}) => setNoteForm({...noteForm, data: {...noteForm.data, title: target.value}})}
                                    required={noteForm?.action !== 'details'}
                                    disabled={noteForm?.action === 'details'}
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>{t("selection.type")}</Form.Label>
                                <Form.Select
                                    name='type'
                                    value={noteForm?.data?.type}
                                    onChange={({target}) => setNoteForm({...noteForm, data: {...noteForm.data, type: target.value}})}
                                    className='p-3'
                                    required={noteForm?.action !== 'details'}
                                    disabled={noteForm?.action === 'details'}
                                >
                                    <option></option>
                                    <option value='note'>{t("selection.note")}</option>
                                    <option value='suggestion'>{t("selection.suggestion")}</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>{t("selection.content")}</Form.Label>
                                <Form.Control
                                    as='textarea'
                                    rows={5}
                                    name='content'
                                    value={noteForm?.data?.content || ''}
                                    onChange={({target}) => setNoteForm({...noteForm, data: {...noteForm.data, content: target.value}})}
                                    required={noteForm?.action !== 'details'}
                                    disabled={noteForm?.action === 'details'}
                                />
                            </Form.Group>
                    </Modal.Body>
                    {
                        noteForm?.action !== 'details'
                        ?
                            <Modal.Footer>
                                <Button type="button" variant="secondary" onClick={() => setNoteForm(null)}>{t("global.cancel")}</Button>
                                <Button type="submit" variant="primary" onClick={handleNoteSubmit}>
                                    {
                                        noteLoading
                                        ?
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"/>
                                        :
                                            t("global.save")
                                    }
                                </Button>
                            </Modal.Footer>
                        :
                            <></>
                    }
                </Form>
            </Modal>
            <Modal show={isMeetingVisible} onHide={() => {setIsMeetingVisible(false)}} fullscreen={true}>
                <Modal.Header closeButton><h4>{t("selection.submenu.interview")}</h4></Modal.Header>
                <Modal.Body>
                    <InterviewSection choose={selectedEvent?.choose} nameSend={school?.name} typeuser={'School'} t={t} />
                </Modal.Body>
            </Modal>
        </>
    )
}